import type { Point, Transform } from "web_myplann/Chat/Types/pinchZoom";

export const zoomAroundPoint = (
	start: Transform,
	anchor: Point,
	scale: number,
): Transform => {
	const ratio = scale / start.scale;

	return {
		scale,
		x: anchor.x - (anchor.x - start.x) * ratio,
		y: anchor.y - (anchor.y - start.y) * ratio,
	};
};
